import { Box, Flex } from '@chakra-ui/react'

import { Switch } from '@/components/ui'

interface FloorListToggleIProps {
  checked: boolean
  onToggle: () => void
}

export const FloorListToggle = ({
  checked,
  onToggle,
}: FloorListToggleIProps) => {
  return (
    <Flex mb='20px'>
      <Switch
        backgroundColor='#2fb2b0'
        ballHeight='12px'
        ballPadding='2px'
        checked={checked}
        dataTestId='floorPlanPage_floorsPanel_filterToggle'
        height='16px'
        onChange={onToggle}
        width='40px'
      />
      <Box
        color='#667289'
        fontSize='11px'
        fontWeight={500}
        lineHeight='16px'
        ml='10px'
      >
        Show only floors with open incidents
      </Box>
    </Flex>
  )
}
